import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import estilos from "../Documentacion.module.css"
import BotonSemaforoComponent from '../BotonesComponent/BotonSemaforoComponent';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { actualizarConstanciaFC27, generarConstanciaFC27 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { Store } from 'react-notifications-component';
import { Checkbox } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { Portal, Typography } from '@mui/material';
import { red, yellow, green } from '@mui/material/colors';
import { ObtenerInformacionCliente } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../../redux/AppDucks';
import TextField from '@mui/material/TextField';
import moment from 'moment';

function DictamenCumplimientoFC27Component(props) {
    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')

    const { dictamenfiscalcliente, dictamenjuridicocliente, dictamenmarcariocliente } = props?.cliente
    const cliente = props?.cliente
    const [destinoVenta, setDestinoVenta] = useState(true);
    const [modalConfirmar, setModalConfirmar] = React.useState(false);

    const [valuesForm, setValuesForm] = React.useState();

    const solicitud = props?.solicitud

    let tituloBoton = 'Nuevo archivo'
    let habilitarBoton = false

    let fechaActual = moment().format('YYYY-MM-DD')
    let fechaEmision = solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.fechaemision?.substring(0, 10)
    let diasVencimiento = moment(fechaActual).diff(moment(fechaEmision), 'days')


    if (diasVencimiento >= 364) habilitarBoton = true
    if (diasVencimiento < 364) tituloBoton = 'Archivo vigente. No es posible actualizar.'

    const handleChange = () => {
        setDestinoVenta(!destinoVenta);
    };

    const handleOpenConfirmar = (values) => {
        setModalConfirmar(true);
        setValuesForm(values)
    }

    const handleCloseConfirmar = () => {
        setModalConfirmar(false);
    }

    const getCategoriaDeMezcal = () => {
        const categoria = solicitud?.fi_25_documenentos?.find(documento => documento?.categoriamezcal != null);
        return categoria?.categoriamezcal
    }


    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };
    const styleForm = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: '60%', height: '90%', bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, 'overflowY': 'scroll',
    };
    const HTMLmodalConfirmar = () => {
        return (
            <Modal
                open={modalConfirmar}
                onClose={handleCloseConfirmar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h5><strong>Generar Constancia de Cumplimiento con la Documentación de Comercializador FC/27</strong></h5>
                    Estás seguro de querer generar esta Constancia?
                    <br></br><br></br>
                    <button onClick={() => btnConstanciaFC27()} className='mt-2 btn btn-success'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }

    let filtrodomicilio = cliente?.domiciliofiscalcliente?.filter(domicilio => domicilio?.isbaja == false && domicilio?.domicilioprincipal == true)
    let cadenaDomicilio = ''
    const arrayDomicilio = []
    if (filtrodomicilio?.[0]?.calle === 'Otro') arrayDomicilio.push(filtrodomicilio?.[0]?.otracalle)
    else arrayDomicilio.push(filtrodomicilio?.[0]?.calle)
    if (filtrodomicilio?.[0]?.numerointerior != null && filtrodomicilio?.[0]?.numerointerior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numerointerior)
    else arrayDomicilio.push('S/N')
    if (filtrodomicilio?.[0]?.numeroexterior != null && filtrodomicilio?.[0]?.numeroexterior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numeroexterior)
    else arrayDomicilio.push('S/N')

    if (filtrodomicilio?.[0]?.colonia != null && filtrodomicilio?.[0]?.colonia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.colonia)
    if (filtrodomicilio?.[0]?.localidad != null && filtrodomicilio?.[0]?.localidad != '') arrayDomicilio.push(filtrodomicilio?.[0]?.localidad)
    if (filtrodomicilio?.[0]?.municipioalcaldia != null && filtrodomicilio?.[0]?.municipioalcaldia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.municipioalcaldia)
    if (filtrodomicilio?.[0]?.estado != null && filtrodomicilio?.[0]?.estado != '') arrayDomicilio.push(filtrodomicilio?.[0]?.estado)
    if (filtrodomicilio?.[0]?.codigopostal != null && filtrodomicilio?.[0]?.codigopostal != '') arrayDomicilio.push(filtrodomicilio?.[0]?.codigopostal)
    for (const i in arrayDomicilio) {
        if (Number(i) === 0) {
            cadenaDomicilio += arrayDomicilio[i]
        } else if (Number(i) + Number(1) === arrayDomicilio.length) {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        } else {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        }
    }

    const btnConstanciaFC27 = async () => {
        await dispatch(actualizarLoadingApp_true())
        const arregloCadena = cliente?.actividadcliente?.map(item => item?.tipoactividad?.actividad || '');
        let combinacionCadena = '';
        if (arregloCadena.length == 1) {
            combinacionCadena = arregloCadena[0];
        } else if (arregloCadena.length > 1) {
            combinacionCadena = arregloCadena.slice(0, -1).join(', ') + ' y ' + arregloCadena.slice(-1);
        }
        let fechaActual = new Date(fechaHoy).toISOString()

        if (solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.length == 0) {
            
            const data = {
                numeroConstancia: valuesForm?.numeroConstancia,
                fechaemisionC: fechaActual,
                numerosocio: cliente?.numerosocio,
                nombrerazonsocial: cliente?.nombrerazonsocial,
                personafisica: cliente.personafisica,
                personamoral: cliente.personamoral,
                acividades: combinacionCadena,
                domicilioFiscal: cadenaDomicilio,
                categoriamezcal: valuesForm.categoriamezcal,
                //JURIDICO
                fechaconstitucion: dictamenjuridicocliente?.[0]?.fechaconstitucion,
                duracionsociedad: dictamenjuridicocliente?.[0]?.duracionsociedad,
                duracionorgano: dictamenjuridicocliente?.[0]?.duracionorgano,
                representantelegal: dictamenjuridicocliente?.[0]?.representantelegal,
                vigenciarepresentante: dictamenjuridicocliente?.[0]?.vigenciarepresentante,
                tiposociedad: dictamenjuridicocliente?.[0]?.tiposociedad,
                //FISCAL
                fechaemision: dictamenfiscalcliente?.[0]?.fechaemision,
                estatuspadron: dictamenfiscalcliente?.[0]?.estatuspadron,
                actividadeseconomicas: dictamenfiscalcliente?.[0]?.actividadeseconomicas,
                regimenfiscal: dictamenfiscalcliente?.[0]?.regimenfiscal,

                dictamenmarcariocliente: dictamenmarcariocliente,

                checkDestinoNacional: valuesForm.checkDestinoNacional,
                checkDestinoExportacion: valuesForm.checkDestinoExportacion,

                norma1: checkboxValues?.norma1,
                norma2: checkboxValues?.norma2,
                norma3: checkboxValues?.norma3,
                norma4: checkboxValues?.norma4,

                checkUsoDeHologramasSi: valuesForm.checkUsoDeHologramasSi,
                checkUsoDeHologramasNo: valuesForm.checkUsoDeHologramasNo,
                embalajeCheck: valuesForm.embalajeCheck,
                folletosCheck: valuesForm.folletosCheck,
                espectacularesCheck: valuesForm.espectacularesCheck,
                rotuladoCheck: valuesForm.rotuladoCheck,
                facturasCheck: valuesForm.facturasCheck,
                paginaCheck: valuesForm.paginaCheck,
                documentoCheck: valuesForm.documentoCheck,
                idsolicitudesocfc01: solicitud?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01, idestatuspdfoc: 1,
            }
            await dispatch(generarConstanciaFC27(data))
        } else {
            const data = {
                numeroConstancia: valuesForm?.numeroConstancia,
                fechaemisionC: fechaActual,
                numerosocio: cliente?.numerosocio,
                nombrerazonsocial: cliente?.nombrerazonsocial,
                personafisica: cliente?.personafisica,
                personamoral: cliente?.personamoral,
                actividades: combinacionCadena,
                domicilioFiscal: cadenaDomicilio,
                categoriamezcal: valuesForm.categoriamezcal,
                //JURIDICO
                fechaconstitucion: dictamenjuridicocliente?.[0]?.fechaconstitucion,
                duracionsociedad: dictamenjuridicocliente?.[0]?.duracionsociedad,
                duracionorgano: dictamenjuridicocliente?.[0]?.duracionorgano,
                representantelegal: dictamenjuridicocliente?.[0]?.representantelegal,
                vigenciarepresentante: dictamenjuridicocliente?.[0]?.vigenciarepresentante,
                tiposociedad: dictamenjuridicocliente?.[0]?.tiposociedad,
                //FISCAL
                fechaemision: dictamenfiscalcliente?.[0]?.fechaemision,
                estatuspadron: dictamenfiscalcliente?.[0]?.estatuspadron,
                actividadeseconomicas: dictamenfiscalcliente?.[0]?.actividadeseconomicas,
                regimenfiscal: dictamenfiscalcliente?.[0]?.regimenfiscal,

                dictamenmarcariocliente: dictamenmarcariocliente,

                checkDestinoNacional: valuesForm.checkDestinoNacional,
                checkDestinoExportacion: valuesForm.checkDestinoExportacion,

                norma1: checkboxValues?.norma1,
                norma2: checkboxValues?.norma2,
                norma3: checkboxValues?.norma3,
                norma4: checkboxValues?.norma4,

                checkUsoDeHologramasSi: valuesForm.checkUsoDeHologramasSi,
                checkUsoDeHologramasNo: valuesForm.checkUsoDeHologramasNo,
                embalajeCheck: valuesForm.embalajeCheck,
                folletosCheck: valuesForm.folletosCheck,
                espectacularesCheck: valuesForm.espectacularesCheck,
                rotuladoCheck: valuesForm.rotuladoCheck,
                facturasCheck: valuesForm.facturasCheck,
                paginaCheck: valuesForm.paginaCheck,
                documentoCheck: valuesForm.documentoCheck,
                idsolicitudesocfc01: solicitud?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01, idestatuspdfoc: 1,
                idsolicitudesocfc27: solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idsolicitudesocfc27,
            }
            await dispatch(actualizarConstanciaFC27(data))
        }
        handleCloseConfirmar()
        await dispatch(ObtenerInformacionCliente(solicitud?.idsolicitudesuifc01))
        await dispatch(actualizarLoadingApp_false())
    }







    const [openModal, setOpenModal] = React.useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    }

    const [checkboxValues, setCheckboxValues] = useState({ norma1: "v", norma2: "v", norma3: "v", norma4: "v" });

    const handleCheckboxChange = (label, value) => {
        setCheckboxValues((prevValues) => ({
            ...prevValues,
            [label]: value,
        }));
    };
    const modalFormulario = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleForm}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}> Certificado NOM </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <div className='row'>
                                <div className={`text-center mb-4 ${estilos.titulo}`}><strong>Constancia de Cumplimiento con la Documentación de Comercializador FC/27 </strong></div>
                                <Formik
                                    initialValues={{
                                        numeroConstancia: '',
                                        categoriamezcal: 'MEZCAL ARTESANAL',
                                        checkDestinoNacional: false,
                                        checkDestinoExportacion: false,
                                        checkUsoDeHologramasSi: false,
                                        checkUsoDeHologramasNo: false,
                                        embalajeCheck: false,
                                        folletosCheck: false,
                                        espectacularesCheck: false,
                                        rotuladoCheck: false,
                                        facturasCheck: false,
                                        paginaCheck: false,
                                        documentoCheck: false
                                    }}
                                    enableReinitialize={true}
                                    validate={values => {
                                        const errors = {};
                                        if (!values.numeroConstancia) {
                                            errors.numeroConstancia = 'Requerido!';
                                        }
                                        return errors;
                                    }}
                                    onSubmit={(values, { setSubmitting }) => {

                                        handleOpenConfirmar(values)
                                        setSubmitting(false);
                                    }}
                                >
                                    <Form>
                                        <div className={`container ${estilos.contenedorForm}`}>
                                            {solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 3 &&
                                                <div className='row'>
                                                    <TextField error id="outlined-error" label="Observaciones Beneficiario" defaultValue="Observaciones beneficiario" multiline
                                                        value={solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.observacionesbeneficiario} />
                                                </div>
                                            }
                                            <div className='row'>
                                                <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <label htmlFor="numeroConstancia">Número de Constancia:</label><br />
                                                </div>
                                                <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <Field type="text" className="form-control" id="numeroConstancia" name="numeroConstancia" />
                                                    <ErrorMessage name="numeroConstancia" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                                <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <label htmlFor="categoriaMezcal">Categoría de Mezcal:</label><br />
                                                </div>
                                                <div className='col-12 col-xs-12 col-md-6 col-lg-6 col-xl-6'>
                                                    <Field type="text" className="form-control" id="categoriaMezcal" name="categoriaMezcal" value={getCategoriaDeMezcal()} />
                                                    <ErrorMessage name="categoriaMezcal" component="div" className={`${estilos.error}`} /><br />
                                                </div>
                                            </div>
                                            <hr></hr>

                                            <div className='row mt-3' style={{ zoom: '1.2' }}>
                                                <div className={`text-center mb-2 ${estilos.titulo2}`}>{/*IV - */}Informe de Etiquetado</div>
                                                <hr></hr>
                                                <div className="col-md-6 mb-6">
                                                    <label className=''> Destino de Venta</label>

                                                </div>

                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor=''>
                                                        <Field className="form-check-input" type="checkbox" name="checkDestinoNacional" id="checkDestinoNacional" />
                                                        <label className=''>Nacional</label>
                                                    </label>

                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="">
                                                        <Field className="form-check-input" type="checkbox" name="checkDestinoExportacion" id="checkDestinoExportacion" />
                                                        <label className=''>Exportación</label>
                                                    </label>
                                                </div>
                                            </div><hr />
                                            <div className='row mt-3' style={{ zoom: '1.2' }}>
                                                <div className={`text-center mb-2 ${estilos.titulo2}`}>Normas</div>
                                                <hr></hr>
                                                <table className='table-responsive'>
                                                    <thead>
                                                        <tr className='text-center'>
                                                            <th colSpan="1" scope="col">Norma de Referencia</th>
                                                            <th colSpan="5" scope="col"></th>
                                                            <th colSpan="3" scope="col">Semaforización de cumplimiento</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="1" className='text-center'>1</td>
                                                            <td colSpan="5"> NOM-070-SCFI-2016 Bebidas Alcohólicas-Mezcal-Especificaciones-Apartado 6.</td>
                                                            <td colSpan="3" className='text-center'>
                                                                <BotonSemaforoComponent defaultValue="v" label="norma1" onChange={handleCheckboxChange} />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="9" className='text-center'> <hr /> </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="1" className='text-center'>2</td>
                                                            <td colSpan="4">NOM-030-SCFI-2006 Información comercial-Declaración de cantidad en la etiqueta-Especificaciones. Apartado 4.</td>
                                                            <td colSpan="4" className='text-center'>
                                                                <BotonSemaforoComponent defaultValue="v" label="norma2" onChange={handleCheckboxChange} />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="9" className='text-center'> <hr /> </td>
                                                        </tr>
                                                        <tr>
                                                            <th colSpan="1" className='text-center'>3</th>
                                                            <td colSpan="4" >NOM-142-SSA1/SCFI-2014 Bebidas Alcohólicas. Especificaciones sanitarias.Etiquetado sanitario y comercial. Apartado 9.</td>
                                                            <td colSpan="4" className='text-center'>
                                                                <BotonSemaforoComponent defaultValue="v" label="norma3" onChange={handleCheckboxChange} />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="9" className='text-center'> <hr /> </td>
                                                        </tr>
                                                        <tr>
                                                            <th colSpan="1" className='text-center'>4</th>
                                                            <td colSpan="4">NOM-106-SCFI-2017<br /> Características de diseño y condicionesde uso de la contraseña oficial. Apartado 3 y 4.</td>
                                                            <td colSpan="4" className='text-center'>
                                                                <BotonSemaforoComponent defaultValue="v" label="norma4" onChange={handleCheckboxChange} />
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div><hr />
                                            <div className='row mt-3' style={{ zoom: '1.2' }}>
                                                <div className={`text-center mb-2 ${estilos.titulo2}`}>Autorizaciones</div>
                                                <hr></hr>
                                                <div className="col-md-6 mb-6">
                                                    <label className=''>Autorización de uso de hologramas:</label>

                                                </div>

                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor='si'>
                                                        <Field className="form-check-input" type="checkbox" name="checkUsoDeHologramasSi" id="checkUsoDeHologramasSi" />
                                                        <label className=''>Si</label>
                                                    </label>

                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="no">
                                                        <Field className="form-check-input" type="checkbox" name="checkUsoDeHologramasNo" id="checkUsoDeHologramasNo" />
                                                        <label className=''>No</label>
                                                    </label>
                                                </div>

                                                <div className="col-md-12 mb-12  mb-2">
                                                    <label className=''>Autorización de uso del signo distintivo CRM en:</label>
                                                    <br />
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor='Embalaje'>
                                                        <Field className="form-check-input" type="checkbox" name="embalajeCheck" id="embalajeCheck" />
                                                        <label className=''>Embalaje</label>
                                                    </label>

                                                </div>

                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor=''>
                                                        <Field className="form-check-input" type="checkbox" name="folletosCheck" id="folletosCheck" />
                                                        <label className=''>Folletos y/o Tríticos</label>
                                                    </label>

                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="">
                                                        <Field className="form-check-input" type="checkbox" name="espectacularesCheck" id="espectacularesCheck" />
                                                        <label className=''>Espectaculares</label>
                                                    </label>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor=''>
                                                        <Field className="form-check-input" type="checkbox" name="rotuladoCheck" id="rotuladoCheck" />
                                                        <label className=''>Rotulado en paredes y/o vehículos</label>
                                                    </label>

                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="">
                                                        <Field className="form-check-input" type="checkbox" name="facturasCheck" id="facturasCheck" />
                                                        <label className=''>Facturas</label>
                                                    </label>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="">
                                                        <Field className="form-check-input" type="checkbox" name="paginaCheck" id="paginaCheck" />
                                                        <label className=''>Página Web</label>
                                                    </label>
                                                </div>
                                                <div className="col-md-3 mb-3">
                                                    <label htmlFor="">
                                                        <Field className="form-check-input" type="checkbox" name="documentoCheck" id="documentoCheck" />
                                                        <label className=''>Otro Documento</label>
                                                    </label>
                                                </div>
                                            </div>
                                            <br /><br />
                                            <div className='text-center'>
                                                <button type="submit" className='btn btn-lg btn-success' /*onClick={() => btnConstanciaFC27()}*/>
                                                    Generar Constancia
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </Formik>
                            </div>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div >
        )
    }

    return (
        <Fragment><br />
            <Tooltip title={tituloBoton}>
                <span>
                    <IconButton size="large" onClick={() => setOpenModal(true)}
                        disabled={solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 4 && habilitarBoton == false}> <NoteAddIcon fontSize="inherit"
                            style={(solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == null ||
                                solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 1 ||
                                solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 2) ? { fill: '#2B2B2B' } :
                                solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 3 ? { fill: 'red' } :
                                    solicitud?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 4 ? { fill: 'green' } : ''} /> </IconButton>
                </span>
            </Tooltip>
            {modalFormulario()}
            {HTMLmodalConfirmar()}
        </Fragment >

    );
};


export default withRouter(DictamenCumplimientoFC27Component)
